import { render, staticRenderFns } from "./Promotion_set_edit.vue?vue&type=template&id=68bc5362&scoped=true&"
import script from "./Promotion_set_edit.vue?vue&type=script&lang=js&"
export * from "./Promotion_set_edit.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_set_edit.vue?vue&type=style&index=0&id=68bc5362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc5362",
  null
  
)

export default component.exports